// auth.util.ts

import { LoginApiResponse } from './auth-response';

// export const isSuccess = (r: LoginApiResponse): r is Extract<LoginApiResponse, { token: string }> => (r as any)?.token;
//
// export const isOtpRequired = (r: LoginApiResponse): r is Extract<LoginApiResponse, { otp_required: true }> =>
//     (r as any)?.otp_required === true;
//
// export const isOtpEnrollment = (
//     r: LoginApiResponse
// ): r is Extract<LoginApiResponse, { otp_enrollment_required: true }> => (r as any)?.otp_enrollment_required === true;
export const isSuccess = (r: LoginApiResponse): r is { token: string } =>
    typeof (r as { token?: unknown }).token === 'string';

export const isOtpRequired = (r: LoginApiResponse): r is { otp_required: true; message?: string } =>
    (r as { otp_required?: unknown }).otp_required === true;

export const isOtpEnrollment = (r: LoginApiResponse): r is { otp_enrollment_required: true; setup_url: string } =>
    (r as { otp_enrollment_required?: unknown }).otp_enrollment_required === true;
